// import { i18n } from '../i18n';
import _ from 'lodash';
import customColumnsExtend from '../custom_columns_extend';
import customFormColumnsExtend from '../custom_form_columns_extend';

export const shareColumnsExtend = (entityColumns, columns) => {
  let newEntityColumns = {}

  _.each(columns, (hash) => {
    if (typeof hash === 'string') {
      newEntityColumns[hash] = entityColumns[hash]
    } else if (hash['key']) {
      newEntityColumns[hash['key']] = _.merge(entityColumns[hash['key']], hash)
    }
  })

  const customColumns = customColumnsExtend(newEntityColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else {
      return _.merge(customColumns[hash['key']], hash)
    }
  })
}

export const shareFormColumnsExtend = (entityColumns, columns, { formColumnsConfig = {}, type, data }) => {
  let newEntityColumns = {}

  _.each(columns, (hash) => {
    if (typeof hash === 'string') {
      newEntityColumns[hash] = entityColumns[hash]
    } else if (hash['key']) {
      newEntityColumns[hash['key']] = _.merge(entityColumns[hash['key']], hash)
    }
  })

  const customColumns = customFormColumnsExtend(newEntityColumns, data)

  let array = columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else {
      return _.merge(customColumns[hash['key']], hash)
    }
  })

  return array.map(hash => {
    if (formColumnsConfig[hash['prop']]) {
      if (formColumnsConfig[hash['prop']]['required'] && _.get(hash, 'renderCell.required') === undefined) {
        _.set(hash, 'renderCell.required', true)
      }

      if (formColumnsConfig[hash['prop']]['disabledUpdate'] && _.get(hash, 'renderCell.props.disabled') === undefined) {
        _.set(hash, 'renderCell.props.disabled', type === 'edit')

        // if (hash['renderCell']['hint'] === undefined) {
        //   hash['renderCell']['hint'] = i18n.t('hint.cannotChangeAfterCreate')
        // }
      }
    }

    return hash
  })
}
